import { useApiQuery } from '../useApiQuery';
import { reminderKeys } from '@/lib/queryKeys';
import { remindersV2 } from '@/lib/api/endpoints';
import { apiGet, operationsClient } from '@/lib/api';
import type { ReminderListParams, ReminderListResponse } from '@/types/reminder';

const DEFAULT_REFETCH_INTERVAL_MS = 30_000;

interface UseRemindersOptions {
  /** Override the polling interval (ms). Pass false to disable. */
  refetchInterval?: number | false;
  enabled?: boolean;
}

/**
 * List reminders with cursor pagination + filters (spec §13).
 *
 * Polls every 30s by default per spec §15 (chose polling over WebSocket for
 * v1.0). Suppress via `refetchInterval: false` for views that handle their
 * own refresh cadence.
 */
export function useReminders(params: ReminderListParams = {}, options: UseRemindersOptions = {}) {
  const { refetchInterval = DEFAULT_REFETCH_INTERVAL_MS, enabled = true } = options;

  return useApiQuery<ReminderListResponse>({
    queryKey: reminderKeys.list(params),
    queryFn: () =>
      apiGet<ReminderListResponse>(operationsClient, remindersV2.list(), {
        params,
      }),
    refetchInterval,
    enabled,
    showErrorToast: false,
  });
}
